import { render } from "./LeadDetails.vue?vue&type=template&id=bd24be44"
import script from "./LeadDetails.vue?vue&type=script&lang=js"
export * from "./LeadDetails.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./LeadDetails.vue?vue&type=style&index=1&id=bd24be44&lang=css"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__